import Phaser from 'phaser';
import { TILE } from '../config';

/**
 * Generate placeholder textures procedurally — no asset loading.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload() {
    this.load.image('player', 'assets/characters/player.png');
    this.load.image('cop',    'assets/characters/cop.png');
    this.load.image('ped_blue',     'assets/characters/ped_blue.png');
    this.load.image('ped_brown',    'assets/characters/ped_brown.png');
    this.load.image('ped_old',      'assets/characters/ped_old.png');
    this.load.image('ped_woman',    'assets/characters/ped_woman.png');
    this.load.image('ped_survivor', 'assets/characters/ped_survivor.png');

    this.load.image('veh_hatch_red',    'assets/cars/hatchback_red.png');
    this.load.image('veh_hatch_green',  'assets/cars/hatchback_green.png');
    this.load.image('veh_hatch_yellow', 'assets/cars/hatchback_yellow.png');
    this.load.image('veh_taxi',         'assets/cars/taxi_black.png');
    this.load.image('veh_police',       'assets/cars/police_blue.png');

    // Kenney roguelike-modern-city atlas — 37×28 grid of 16×16 tiles
    this.load.spritesheet('cityatlas', 'assets/tiles/city.png', { frameWidth: 16, frameHeight: 16 });
  }

  create() {
    this.makeTile('tile_road', 0x2a2a2a, 0x1f1f1f);
    this.makeTile('tile_road_line', 0x2a2a2a, 0xeeee55, true);
    this.makeTile('tile_pavement', 0x8a8a8a, 0x707070);
    this.makeTile('tile_grass', 0x2f7a2f, 0x256025);
    this.makeTile('tile_water', 0x2a5fb0, 0x224f95);
    this.makeTile('tile_pitch', 0x36993a, 0x2c8030);
    this.makeTile('tile_stadium', 0xb01818, 0x801010);
    this.makeTile('tile_warehouse', 0x6b4a2b, 0x553a22);
    this.makeTile('tile_building_a', 0x555555, 0x3a3a3a);
    this.makeTile('tile_building_b', 0x6e5a3a, 0x4f4128);
    this.makeTile('tile_building_c', 0x4a4a6a, 0x33334a);

    // Parcel + marker
    this.makeRect('parcel', 14, 14, 0xc89b3c, 0x3a2a10);
    this.makeRect('marker', 24, 24, 0xffe24a, 0x000000);
    // Bullet/punch FX
    this.makeRect('hit_fx', 6, 6, 0xffffff, 0xff5555);

    this.scene.start('MenuScene');
  }

  private makeTile(key: string, fill: number, edge: number, withLine = false) {
    const g = this.add.graphics({ x: 0, y: 0 });
    g.fillStyle(fill, 1).fillRect(0, 0, TILE, TILE);
    g.lineStyle(1, edge, 1).strokeRect(0, 0, TILE, TILE);
    if (withLine) {
      g.fillStyle(0xeeee55, 1).fillRect(TILE / 2 - 1, 4, 2, TILE - 8);
    }
    g.generateTexture(key, TILE, TILE);
    g.destroy();
  }

  private makeRect(key: string, w: number, h: number, fill: number, edge: number) {
    const g = this.add.graphics({ x: 0, y: 0 });
    g.fillStyle(fill, 1).fillRect(0, 0, w, h);
    g.lineStyle(1, edge, 1).strokeRect(0, 0, w, h);
    g.generateTexture(key, w, h);
    g.destroy();
  }

}
